import type { RowClickedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router';

import LoadingIndicator from '@/components/LoadingIndicator';
import { DEFAULT_GRID_SETTINGS } from '@/constants/common.ts';
import useGridTheme from '@/hooks/useGridTheme';
import { useFetchAssetVulnerabilities } from '@/pages/Assets';
import { selectedOrganizationIdAtom } from '@/pages/Organizations/Organizations.store';

import { ASSET_VULNERABILITIES_TABLE_COLUMNS } from './AssetVulnerabilitiesTable.constants';

const LoadingOverlay = () => <LoadingIndicator isLoading />;

const AssetVulnerabilitiesTable = ({ assetId }: { assetId: number }) => {
  const { data: assetVulnerabilities, isLoading } =
    useFetchAssetVulnerabilities(assetId || 0);
  const gridTheme = useGridTheme();
  const navigate = useNavigate();
  const [selectedOrgId] = useAtom(selectedOrganizationIdAtom);

  const gridOptions = {
    ...DEFAULT_GRID_SETTINGS
  };

  const handleRowClick = (event: RowClickedEvent) => {
    const vulnerabilityName = event.data.name || event.data.vulnerability_name;
    const vulnerabilityOrgId = event.data.organization_id;
    if (vulnerabilityName && selectedOrgId === vulnerabilityOrgId) {
      navigate(
        `/vulnerability-management/vulnerability-details/${vulnerabilityName}`
      );
    }
  };

  return (
    <AgGridReact
      gridOptions={gridOptions}
      rowData={assetVulnerabilities}
      columnDefs={ASSET_VULNERABILITIES_TABLE_COLUMNS}
      theme={gridTheme}
      paginationPageSize={20}
      loadingOverlayComponent={LoadingOverlay}
      loading={isLoading}
      overlayNoRowsTemplate="No vulnerabilities found"
      onRowClicked={(event) => {
        handleRowClick(event);
      }}
    />
  );
};

export default AssetVulnerabilitiesTable;
